import type { MyPageConfig } from '../../@types/context/my-page-config.types';

/**
 * MVX-598 (CCD2 R04): every Swedish brand shows the automated-decision notice
 * and the credit-intermediary footer. Both texts are Swedish locale strings;
 * this only turns them on.
 *
 * MVX-602 (CCD2 R10): no "recommended" badge; the engine's rank-1 offer is
 * labelled by its criterion instead.
 */
export const myPageCcd2SeOptions: Pick<
  MyPageConfig['options'],
  | 'hasAutomatedDecisionNotice'
  | 'hasCreditIntermediaryFooter'
  | 'hasCriterionLabel'
> = {
  hasAutomatedDecisionNotice: true,
  hasCreditIntermediaryFooter: true,
  hasCriterionLabel: true,
};
